import { CardDescription } from "@/shared/components/common/Card";
import Flex from "@/shared/components/common/Flex";
import type { PhosphorIconName } from "@/shared/components/common/PhosphorIcon";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import Typography from "@/shared/components/common/Typography";

interface RoomCardDescriptionProps {
  title: string;
  description?: string | number;
  icon?: PhosphorIconName;
}

export default function RoomCardDescription({
  title,
  description,
  icon,
}: RoomCardDescriptionProps) {
  return (
    <CardDescription>
      <Flex alignItems={"center"} gap={"1"}>
        {icon && (
          <PhosphorIcon name={icon} size={20} className="text-foreground" />
        )}

        <Typography variant={"body2"}>{description}</Typography>
        <Typography variant={"body3"} className="text-muted- dark:text-muted">
          {title}
        </Typography>
      </Flex>
    </CardDescription>
  );
}
